<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 255 255" style="enable-background:new 0 0 255 255;" xml:space="preserve">
  <g id="arrow-drop-down">
		<polygon points="0,63.75 127.5,191.25 255,63.75"/>
  </g>
</svg>
